import { useEffect, useState } from "react";
import api, { formatPrice } from "@/lib/api";

export default function AdminCustomers() {
    const [customers, setCustomers] = useState([]);
    useEffect(() => { api.get("/admin/customers").then(({ data }) => setCustomers(data.customers)); }, []);
    return (
        <div>
            <h1 className="text-2xl font-semibold mb-6">Customers</h1>
            <div className="bg-white border border-gray-200 rounded-lg overflow-x-auto">
                <table className="w-full text-sm">
                    <thead className="bg-gray-50 border-b border-gray-200 text-gray-500 text-xs uppercase"><tr><th className="text-left p-4">Name</th><th className="text-left p-4">Email</th><th className="text-left p-4">Phone</th><th className="text-left p-4">Orders</th><th className="text-left p-4">Joined</th></tr></thead>
                    <tbody className="divide-y divide-gray-100">
                        {customers.length === 0 ? <tr><td colSpan={5} className="p-8 text-center text-gray-400">No customers yet.</td></tr> :
                        customers.map((c) => (
                            <tr key={c.id}><td className="p-4 font-medium">{c.name}</td><td className="p-4">{c.email}</td><td className="p-4">{c.phone || "—"}</td><td className="p-4">{c.order_count}</td><td className="p-4">{(c.created_at || "").slice(0, 10)}</td></tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
